import React, { useEffect } from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import { WcbQueueType } from '../types/WcbQueueType';

type WcbQueueSelectProps = {
    iimclient: ConfigClientType;
    wcbQueues: Array<WcbQueueType>;
    isDisabled?: boolean;
    selectedQueueId?: string;
    changeSelectedQueueId: Function;
};

const WcbQueueSelect = ({
    iimclient,
    wcbQueues,
    isDisabled,
    selectedQueueId,
    changeSelectedQueueId,
}: WcbQueueSelectProps) => {
    const segment = iimclient.segment;

    const defaultQueueId = () => {
        const defaultQueue = wcbQueues.find((queue) => queue.isdefault || wcbQueues.length === 1);
        return defaultQueue ? defaultQueue.cbqueueid.toString() : '';
    };

    const selectedOrDefaultQueueId = selectedQueueId ? selectedQueueId : defaultQueueId();

    useEffect(() => {
        if (selectedOrDefaultQueueId !== selectedQueueId) {
            changeSelectedQueueId(selectedOrDefaultQueueId);
        }
    }, [wcbQueues]);

    const wcbQueueOptions = () => {
        const notSelectedOption = (
            <option key="0" value="" disabled hidden>
                {segment ? segment.labelnoquestionselected : 'labelnoquestionselected'}
            </option>
        );

        if (!wcbQueues.length) return notSelectedOption;

        const options = wcbQueues.map((queue, index) => (
            <option key={index + 1} value={queue.cbqueueid}>
                {queue.questiontext}
            </option>
        ));

        return [notSelectedOption, ...options];
    };

    return (
        <select
            name="wcb-queueid"
            id="wcb-queueid"
            className="if dropdown-select"
            aria-labelledby="wcb-labelquestion"
            disabled={isDisabled}
            value={selectedOrDefaultQueueId}
            onChange={(e) => changeSelectedQueueId(e.target.value)}
        >
            {wcbQueueOptions()}
        </select>
    );
};

export default WcbQueueSelect;
